var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewHealth',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('health-table',{ref:"table",attrs:{"title":"Users"},on:{"addHealth":_vm.showHealthModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }